import React, { PureComponent } from 'react';

import { connect } from 'react-redux';
import { getFormTags, removeFormTag } from './../actions';
import Loader from '../../components/loader';
import FormTagItem from './FormTagItem';
import { RootState } from 'gf-types';
import { FormTag } from '../tags-types';

export type FormTagsProps = {
  formId?: string;
  tags?: FormTag[];
  loading?: boolean;
  getFormTags?: (id: string) => void;
  removeFormTag?: () => void;
};

//@ts-ignore - FIX
@connect(
  (state: RootState) => ({
    tags: state.tags?.formTags,
    loading: state.tags?.formTagsLoading
  }),
  { getFormTags, removeFormTag }
)
export default class FormTags extends PureComponent<FormTagsProps, FormTag> {
  constructor(props: FormTagsProps) {
    super(props);
  }

  componentDidMount() {
    this.props.getFormTags(this.props.formId);
  }

  render() {
    const { tags, loading } = this.props;

    if (loading) {
      return (
        <div className="form-tags">
          <Loader isLoading />
        </div>
      );
    }

    const items = [];
    if (tags) {
      for (const tag of tags) {
        items.push(<FormTagItem key={tag.tagId} tag={tag} onRemove={this.props.removeFormTag} />);
      }
    }

    return <div className="form-tags">{items}</div>;
  }
}
